import {createContext} from 'react';

const contactenosContext = createContext();

export default contactenosContext;